import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import WithUser from '../../sub-ui/js/WithUser';
import EscHandler from '../../ui-components/EscHandler';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// set up google analytics and other tracking
require('../../ui-components/buildsite-tracking');
// load business logic
require('../../business/public')();

require('../../mla-c/0.3/public')();

require('../scss/main.scss');

import PublicContainer from './modules/public-container';
import Modal from '../../ui-components/modal';
import Spinner from '../../ui-components/spinner';
import UnauthNotify from '../../ui-components/unauth-notify';

function App(props) {
  return (
    <WithUser>
      <>
        <Helmet>
          <title>Submittal.com</title>
        </Helmet>
        <EscHandler/>
        <UnauthNotify isPublic={true} />
        <Spinner />
        <Modal />
        <PublicContainer />
      </>
    </WithUser>
  );
}

const router = createBrowserRouter([
  { path: "/*", element: <App /> }
]);

const container = document.getElementById('react_container');
const root = createRoot(container);
root.render(<HelmetProvider><RouterProvider router={router} /></HelmetProvider>);
